import { useQuery } from "@tanstack/react-query";
import { CACHE_KEYS } from "@api/constants/cacheKeys";
import { useState } from "react";
import URLS from "@api/constants/urls";
import { handleGlobalGetRequestQuery } from "@api/functions/getRequests";
import useGlobalDebounceHandler from "./useGlobalDebounceHandler";

interface IGetAllInsurerServiceProps {
  page?: string;
  per_page?: string;
  enableQuery?: boolean;
}

interface IGetSingleInsurersServiceProps {
  insurers_id?: string | number;
}

// Get Api service for insurers
export const useGetAllInsurersService = ({
  page = "1",
  per_page = "15",
  enableQuery = true,
}: IGetAllInsurerServiceProps) => {
  const [searchQuery, setSearchQuery] = useState("");
  const { debouncedQuery } = useGlobalDebounceHandler(searchQuery);

  const allInsurersServices = useQuery({
    queryKey: [...CACHE_KEYS.INSURERS, debouncedQuery, page, per_page],
    queryFn: () =>
      handleGlobalGetRequestQuery({
        url: URLS.INSURERS,
        searchParams: {
          "filter[name]": debouncedQuery,
          page,
          per_page,
          include: "products_count",
        },
      }),
    enabled: enableQuery,
  });

  return {
    services: { allInsurersServices },
    states: { searchQuery, setSearchQuery },
  };
};

export const useGetSingleInsurersServices = ({
  insurers_id,
}: IGetSingleInsurersServiceProps) => {
  const singelInsurerService = useQuery({
    queryKey: [...CACHE_KEYS.INSURER, insurers_id],
    queryFn: () =>
      handleGlobalGetRequestQuery({
        url: `${URLS.INSURERS}/${insurers_id}`,
      }),
    enabled: !!insurers_id,
  });
  return {
    services: { singelInsurerService },
  };
};
